import { createSlice } from "@reduxjs/toolkit";

export const uploadSlice = createSlice({
  name: "upload",
  initialState: {
    uploads: [], // Array of upload objects with transaction_id, files, status, etc.
    isUploading: false,
    error: null,
  },
  reducers: {
    startUpload: (state, action) => {
      const { transaction_id, files } = action.payload;
      state.uploads.push({
        transaction_id,
        files: files.map(file => ({
          name: file.name,
          size: file.size,
          type: file.type,
        })),
        status: 'uploading',
        progress: 0,
        created_at: new Date().toISOString(),
        media_ids: [],
      });
      state.isUploading = true;
      state.error = null;
    },
    updateUploadProgress: (state, action) => {
      const { transaction_id, progress } = action.payload;
      const upload = state.uploads.find(u => u.transaction_id === transaction_id);
      if (upload) {
        upload.progress = progress;
      }
    },
    updateUploadStatus: (state, action) => {
      const { transaction_id, status, media_ids } = action.payload;
      const upload = state.uploads.find(u => u.transaction_id === transaction_id);
      if (upload) {
        upload.status = status;
        if (media_ids) {
          upload.media_ids = media_ids;
        }
        if (status === 'completed' || status === 'failed') {
          // Check if any uploads are still in progress
          const hasActiveUploads = state.uploads.some(u => u.status === 'uploading');
          state.isUploading = hasActiveUploads;
        }
      }
    },
    removeUpload: (state, action) => {
      const transaction_id = action.payload;
      state.uploads = state.uploads.filter(u => u.transaction_id !== transaction_id);
      // Update isUploading status
      const hasActiveUploads = state.uploads.some(u => u.status === 'uploading');
      state.isUploading = hasActiveUploads;
    },
    clearCompletedUploads: (state) => {
      state.uploads = state.uploads.filter(u => u.status !== 'completed');
    },
    setUploadError: (state, action) => {
      const { transaction_id, error } = action.payload;
      const upload = state.uploads.find(u => u.transaction_id === transaction_id);
      if (upload) {
        upload.status = 'failed';
        upload.error = error;
      }
      state.error = error;
      // Check if any uploads are still in progress
      const hasActiveUploads = state.uploads.some(u => u.status === 'uploading');
      state.isUploading = hasActiveUploads;
    },
    clearUploadError: (state) => {
      state.error = null;
    },
  }
});

export const {
  startUpload,
  updateUploadProgress,
  updateUploadStatus,
  removeUpload,
  clearCompletedUploads,
  setUploadError,
  clearUploadError
} = uploadSlice.actions;

export default uploadSlice.reducer;
